import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  linksUteis: []
});

function linkUtilReducer(state = initialState, action) {
  switch (action.type) {
    case types.LINKS_UTEIS_START: {
      return startLoad(state);
    }

    case types.LINKS_UTEIS_ERROR: {
      return endLoad(state);
    }

    case types.LINKS_UTEIS_SUCCESS: {
      return endLoad(state.set('linksUteis', fromJS(action.payload)));
    }
  }

  return state;
}

export default linkUtilReducer;
